import { ConfirmModalProps } from "@/components/modals/confirm-modal";

type ShowAlertFn = (options: AlertOptions) => void;

let alertHandler: ShowAlertFn | null = null;

export const setAlertHandler = (handler: ShowAlertFn) => {
  alertHandler = handler;
};

export const showAlert = (options: AlertOptions) => {
  if (!alertHandler) {
    console.warn("Alert handler not initialized yet");
    return;
  }
  alertHandler(options);
};

export type AlertOptions = Partial<ConfirmModalProps> &
  Pick<ConfirmModalProps, "title" | "text">;
